// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__qNUTN","inputWrap":"CustomTip_inputWrap__3bGTA"};